<div class="toolbar-break"></div>
@for (policy of policies$ | async; track policy) {
  @if (policy.policyType === terms) {
    <div class="container my-5">
      <div [innerHTML]="policy.html">
      </div>
    </div>
  }
}